import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './components/inicio/inicio.component'
import { NoticiasComponent } from './components/noticias/noticias.component'
import { MensajeComponent } from './components/mensaje/mensaje.component'
import { PredialComponent } from './components/predial/predial.component'
import { ConstruccionComponent } from './components/construccion/construccion.component'
import { ConsultaSaldoComponent } from './components/consulta-saldo/consulta-saldo.component'
import { DesgloseSaldoComponent } from './components/desglose-saldo/desglose-saldo.component'
import { CiacComponent } from './components/ciac/ciac.component'
import { TransparenciaComponent } from './components/transparencia/transparencia.component'
import { QuejatelComponent } from './components/quejatel/quejatel.component'
import { ConvocatoriasComponent } from './components/convocatorias/convocatorias.component'
import { CabildoComponent } from './components/cabildo/cabildo.component'
import { InformacionComponent } from './components/informacion/informacion.component'
import { SolicitudComponent } from './components/solicitud/solicitud.component'
import { BecasComponent } from './components/becas/becas.component'
import { EducacionComponent } from './components/educacion/educacion.component'
import { ResultadosComponent } from './components/resultados/resultados.component'
import { ResultadosdetalleComponent } from './components/resultadosdetalle/resultadosdetalle.component'
import { VariosComponent } from './components/varios/varios.component'
import { InternetmunicipalComponent } from './components/internetmunicipal/internetmunicipal.component'
import { PropuestasComponent } from './components/propuestas/propuestas.component'
import { ApoyosComponent } from './components/apoyos/apoyos.component'

const routes: Routes = [
  {
    path: 'facturacion',
    redirectTo: 'https://generarcfdi.mx/MunicipioNuevoLaredo',
    pathMatch: 'full'
  },
   {path: "inicio", component: InicioComponent},
   {path: "construccion", component: ConstruccionComponent},
   {path: "noticias", component: NoticiasComponent},
   {path: "mensaje", component: MensajeComponent},
   {path: "predial", component: PredialComponent },
   {path: "consulta_saldo", component: ConsultaSaldoComponent },
   {path: "desglose_saldo", component: DesgloseSaldoComponent },
   {path: "ciac", component: InicioComponent },
   {path: "transparencia", component: TransparenciaComponent },
   {path: "diga", component: QuejatelComponent },
  { path: "cabildo", component: CabildoComponent },
  { path: "convocatorias", component: InicioComponent },
  { path: "informacion", component: InicioComponent },
  { path: "solicitud", component: InicioComponent },
  { path: "becas", component: BecasComponent },
  { path: "educacion", component: InicioComponent },
  { path: "resultados", component: ResultadosComponent },
  { path: "resultadosdetalle", component: ResultadosdetalleComponent },
  { path: "varios", component: VariosComponent },
  { path: "propuestas", component: PropuestasComponent },
  { path: "internetmunicipal", component: InternetmunicipalComponent },
  { path: "apoyos", component: InicioComponent },
   {path: '**', component: InicioComponent}, 
   {path: "",redirectTo:"/inicio",pathMatch:"full"}
   
  
  
  ];


@NgModule({
 
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
